export default __webpack_public_path__ + "locales/zh-CN/FillPDFDialog.json?hash=a390cf15eec5c17811a535ec865016d1";